import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import {
  AlertNotification,
  Relationship,
  Country,
  Bank
} from '../models';

/**
 * Common Service for IH API
 * Handles common/shared data like alerts, relationships, and countries
 */
@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseHttpService {
  private readonly COMMON_ENDPOINT = 'common';

  /**
   * Get customer notifications (Phase 5 / C3)
   * GET /api/ih/common/alerts/{phone} — returns a raw array (not ApiResponse-wrapped), so use getRaw.
   * Read-state is handled client-side by NotificationService (no server mark-read for customers).
   */
  getAlerts(phone: string): Observable<AlertNotification[]> {
    return this.getRaw<AlertNotification[]>(`${this.COMMON_ENDPOINT}/alerts/${phone}`);
  }

  /**
   * Get all relationships
   * GET /api/ih/common/relationships
   */
  getRelationships(): Observable<Relationship[]> {
    return this.get<Relationship[]>(`${this.COMMON_ENDPOINT}/relationships`);
  }

    /**
   * Get all countries
   * GET /api/ih/common/countries
   */
  getCountries(): Observable<Country[]> {
    return this.get<Country[]>(`${this.COMMON_ENDPOINT}/countries`);
  }

  /**
   * Get all banks
   * GET /api/ih/common/banks
   */
  getAllBanks(): Observable<Bank[]> {
    return this.get<Bank[]>(`${this.COMMON_ENDPOINT}/banks`);
  }

  getPremiumByPaymentTerm(planId: string, paymentTerm: string): Observable<any> {
    const baseUrl = this.apiUrl.replace('/api/ih', '/api');
    const params = new HttpParams().set('planId', planId).set('paymentTerm', paymentTerm);
    return this.http.get<any>(`${baseUrl}/i4u/Common/premium-by-payment-term`, { params });
  }

  /**
   * Fetch a setting value by id from common/setting/{id}
   */
  getSetting(id: number) {
    return this.getRaw<any>(`${this.COMMON_ENDPOINT}/setting/${id}`);
  }
}
